import ContentHeader from "../components/ContentHeader";
import Form from "./components/Form";

import styles from "./Info.module.scss";

const Info = ({ isLoggedIn }) => {
  return (
    <div className={styles.wrapper}>
      <ContentHeader title="My Info" />

      <Form isLoggedIn={isLoggedIn} />
    </div>
  );
};

export default Info;
